const ILLEGAL_FILENAME = /[<>:"/\\|?*]/g;

export function sanitizeExportFilename(name: string): string {
  const clean = name
    .normalize('NFKC')
    .split('')
    .map((character) => (character.charCodeAt(0) < 32 ? '-' : character))
    .join('')
    .replace(ILLEGAL_FILENAME, '-')
    .replace(/\.{2,}/g, '.')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[.\s-]+|[.\s-]+$/g, '')
    .slice(0, 80);
  return clean || 'funnel';
}

export function exportFilename(name: string, extension: 'png' | 'pdf' | 'darkfunnels.json') {
  return `${sanitizeExportFilename(name)}-${new Date().toISOString().slice(0, 10)}.${extension}`;
}
